import Vue from 'vue';
import store from '@/store';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import i18n from '@/i18n';

export const helpService = {
  async requestPasswordReset(param) {
    return Vue.axios
      .post('/account/password-reset', {
        ...param
      })
      .then(response => response.data)
      .catch(err => err.data);
  },

  async changePassword(params) {
    return Vue.axios
      .post('/account/password-reset/save', {
        ...params
      })
      .then(response => response.data);
  },

  async downloadUserGuide(userGuide) {
    let response;
    try {
      response = await Vue.axios({
        url: `/user-guide/${userGuide}/download`,
        method: 'GET',
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${userGuide} UG.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (e) {
      const status = e.status;
      let message;
      switch (status) {
        case 403:
          message = i18n.t('attachments.errors.forbiddenView');
          break;
        case 404:
          message = i18n.t('attachments.errors.notFound');
          break;
        default:
          message = i18n.t('attachments.errors.unknown', { status });
      }

      store.dispatch(TolErrorsActions.SetError, { message });
    }
  }
};
